import Axios from 'axios';
import restClient from 'config/httpClient';

export const uploadMedia = async (file, url, fields, onUploadProgress) => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append('file', file);

  return Axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const getSignedUploadUrl = async (url, params) => {
  const result = await restClient.get(url, { params });
  return result?.data;
};
